/* Generated by scripts/extract-sdk-shapes.mjs — do not hand-edit. */
export type SdkShape = {
  path: string[]
  query: string[]
  hasBody: boolean
}

export const SDK_SHAPES: Record<string, SdkShape> = {
  "loginAccessToken": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "refreshAccessToken": {
    "path": [],
    "query": [],
    "hasBody": false
  },
  "completeSessionHandoff": {
    "path": [],
    "query": [
      "token",
      "next"
    ],
    "hasBody": false
  },
  "logout": {
    "path": [],
    "query": [],
    "hasBody": false
  },
  "checkAuth": {
    "path": [],
    "query": [],
    "hasBody": false
  },
  "recoverPassword": {
    "path": [
      "email"
    ],
    "query": [],
    "hasBody": false
  },
  "resetPassword": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "recoverPasswordHtmlContent": {
    "path": [
      "email"
    ],
    "query": [],
    "hasBody": false
  },
  "startSessionHandoff": {
    "path": [],
    "query": [
      "brand",
      "next"
    ],
    "hasBody": false
  },
  "flowerAuth": {
    "path": [],
    "query": [],
    "hasBody": false
  },
  "getCsrfToken": {
    "path": [],
    "query": [],
    "hasBody": false
  },
  "setActiveBrandMe": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "readMyPartners": {
    "path": [],
    "query": [],
    "hasBody": false
  },
  "setCurrentPartnerMe": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "readUsers": {
    "path": [],
    "query": [
      "skip",
      "limit"
    ],
    "hasBody": false
  },
  "createUser": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "deleteUserMe": {
    "path": [],
    "query": [],
    "hasBody": false
  },
  "readUserMe": {
    "path": [],
    "query": [],
    "hasBody": false
  },
  "updateUserMe": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "updatePasswordMe": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "clearProfileImageMe": {
    "path": [],
    "query": [],
    "hasBody": false
  },
  "readProfileImageMe": {
    "path": [],
    "query": [],
    "hasBody": false
  },
  "setProfileImageMe": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "registerUser": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "readServiceAccounts": {
    "path": [],
    "query": [
      "skip",
      "limit"
    ],
    "hasBody": false
  },
  "createServiceAccount": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "deleteUser": {
    "path": [
      "user_id"
    ],
    "query": [],
    "hasBody": false
  },
  "readUserById": {
    "path": [
      "user_id"
    ],
    "query": [],
    "hasBody": false
  },
  "updateUser": {
    "path": [
      "user_id"
    ],
    "query": [],
    "hasBody": true
  },
  "getLoginHistory": {
    "path": [
      "user_id"
    ],
    "query": [],
    "hasBody": false
  },
  "generateApiKeyForUser": {
    "path": [
      "user_id"
    ],
    "query": [],
    "hasBody": true
  },
  "listApiKeysForUser": {
    "path": [
      "user_id"
    ],
    "query": [],
    "hasBody": false
  },
  "updateApiKeyForUser": {
    "path": [
      "user_id",
      "api_key_id"
    ],
    "query": [],
    "hasBody": true
  },
  "testEmail": {
    "path": [],
    "query": [
      "email_to"
    ],
    "hasBody": false
  },
  "cspReport": {
    "path": [],
    "query": [],
    "hasBody": false
  },
  "internalHealthCheck": {
    "path": [],
    "query": [],
    "hasBody": false
  },
  "connectionStatus": {
    "path": [],
    "query": [],
    "hasBody": false
  },
  "metrics": {
    "path": [],
    "query": [],
    "hasBody": false
  },
  "utilsGetGrafanaMcpContext": {
    "path": [],
    "query": [
      "log_query",
      "query_template",
      "start",
      "end",
      "limit",
      "direction"
    ],
    "hasBody": false
  },
  "smsHandler": {
    "path": [],
    "query": [],
    "hasBody": false
  },
  "listAgentRuns": {
    "path": [],
    "query": [
      "skip",
      "limit",
      "agentName",
      "runType",
      "status",
      "referralId",
      "claimId",
      "userId",
      "taskId",
      "fromDate",
      "toDate"
    ],
    "hasBody": false
  },
  "getAgentRunSummary": {
    "path": [],
    "query": [
      "fromDate",
      "toDate"
    ],
    "hasBody": false
  },
  "getAgentRun": {
    "path": [
      "run_id"
    ],
    "query": [],
    "hasBody": false
  },
  "getAiclaimsDashboardSummary": {
    "path": [],
    "query": [
      "fromDate",
      "toDate"
    ],
    "hasBody": false
  },
  "getAiclaimsWorkflowCards": {
    "path": [],
    "query": [
      "fromDate",
      "toDate"
    ],
    "hasBody": false
  },
  "listCallAnalysisWorkflows": {
    "path": [],
    "query": [
      "partnerId"
    ],
    "hasBody": false
  },
  "uploadCallAnalysis": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "listCallAnalysisJobs": {
    "path": [],
    "query": [
      "skip",
      "limit",
      "partnerId"
    ],
    "hasBody": false
  },
  "getCallAnalysisJob": {
    "path": [
      "job_id"
    ],
    "query": [],
    "hasBody": false
  },
  "submitCallAnalysisJob": {
    "path": [
      "job_id"
    ],
    "query": [],
    "hasBody": true
  },
  "auditBatchEndpoint": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "auditRerunEndpoint": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "getAuditBatchEndpoint": {
    "path": [
      "batch_id"
    ],
    "query": [],
    "hasBody": false
  },
  "listAuditBatchesEndpoint": {
    "path": [],
    "query": [
      "partnerId",
      "skip",
      "limit"
    ],
    "hasBody": false
  },
  "downloadCallAuditOutput": {
    "path": [
      "run_id"
    ],
    "query": [
      "channel"
    ],
    "hasBody": false
  },
  "getCallAuditConfigEndpoint": {
    "path": [],
    "query": [
      "partnerId"
    ],
    "hasBody": false
  },
  "upsertCallAuditConfigEndpoint": {
    "path": [],
    "query": [
      "partnerId"
    ],
    "hasBody": true
  },
  "generatePrompt": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "generateWorkflow": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "generateOutput": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "commitWorkflow": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "getGtaReferralSnapshot": {
    "path": [
      "referral_id"
    ],
    "query": [],
    "hasBody": false
  },
  "patchGtaReferralField": {
    "path": [
      "referral_id",
      "field_key"
    ],
    "query": [],
    "hasBody": true
  },
  "getGtaReferralHistory": {
    "path": [
      "referral_id"
    ],
    "query": [
      "limit"
    ],
    "hasBody": false
  },
  "listGtaReferralReports": {
    "path": [
      "referral_id"
    ],
    "query": [],
    "hasBody": false
  },
  "downloadGtaReferralReport": {
    "path": [
      "referral_id",
      "upload_id"
    ],
    "query": [],
    "hasBody": false
  },
  "getRunInspection": {
    "path": [
      "referral_id"
    ],
    "query": [
      "fromDate",
      "toDate"
    ],
    "hasBody": false
  },
  "listRegisteredWorkflowEngines": {
    "path": [],
    "query": [],
    "hasBody": false
  },
  "listWorkflows": {
    "path": [],
    "query": [
      "statusFilter"
    ],
    "hasBody": false
  },
  "createWorkflow": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "getWorkflow": {
    "path": [
      "workflow_id"
    ],
    "query": [],
    "hasBody": false
  },
  "updateWorkflow": {
    "path": [
      "workflow_id"
    ],
    "query": [],
    "hasBody": true
  },
  "cloneWorkflow": {
    "path": [
      "workflow_id"
    ],
    "query": [],
    "hasBody": true
  },
  "testWorkflowOnClaim": {
    "path": [
      "workflow_id"
    ],
    "query": [],
    "hasBody": true
  },
  "compareWorkflows": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "listWorkflowBillingEvents": {
    "path": [],
    "query": [
      "skip",
      "limit",
      "partnerId",
      "workflowKey",
      "billingPeriod",
      "status",
      "evaluationMode"
    ],
    "hasBody": false
  },
  "getEventsForBillingPeriod": {
    "path": [],
    "query": [
      "billingPeriod",
      "partnerId",
      "status"
    ],
    "hasBody": false
  },
  "getWorkflowBillingEventById": {
    "path": [
      "event_id"
    ],
    "query": [],
    "hasBody": false
  },
  "patchWorkflowBillingEvent": {
    "path": [
      "event_id"
    ],
    "query": [],
    "hasBody": true
  },
  "markBillingEventsBilled": {
    "path": [],
    "query": [
      "invoiceId"
    ],
    "hasBody": true
  },
  "readPartners": {
    "path": [],
    "query": [
      "skip",
      "limit"
    ],
    "hasBody": false
  },
  "createPartner": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "deletePartner": {
    "path": [
      "id"
    ],
    "query": [],
    "hasBody": false
  },
  "readPartner": {
    "path": [
      "id"
    ],
    "query": [],
    "hasBody": false
  },
  "updatePartner": {
    "path": [
      "id"
    ],
    "query": [],
    "hasBody": true
  },
  "readMyPages": {
    "path": [],
    "query": [],
    "hasBody": false
  },
  "readPermissionCatalog": {
    "path": [],
    "query": [],
    "hasBody": false
  },
  "wyseaiReadBootstrap": {
    "path": [],
    "query": [
      "partnerId",
      "previewPartnerId",
      "previewAs"
    ],
    "hasBody": false
  },
  "wyseaiListPartners": {
    "path": [],
    "query": [],
    "hasBody": false
  },
  "wyseaiReadPartnerEntitlements": {
    "path": [
      "partner_id"
    ],
    "query": [],
    "hasBody": false
  },
  "wyseaiUpsertPartnerEntitlement": {
    "path": [
      "partner_id",
      "module_id"
    ],
    "query": [],
    "hasBody": true
  },
  "wyseaiReadHomeSummary": {
    "path": [],
    "query": [
      "partnerId",
      "previewPartnerId"
    ],
    "hasBody": false
  },
  "wyseaiListPartnerRuns": {
    "path": [],
    "query": [
      "partnerId",
      "previewPartnerId",
      "page",
      "perPage",
      "status",
      "agentName",
      "fromDate",
      "toDate"
    ],
    "hasBody": false
  },
  "wyseaiReadPartnerRun": {
    "path": [
      "run_id"
    ],
    "query": [
      "partnerId",
      "previewPartnerId"
    ],
    "hasBody": false
  },
  "wyseaiReadDashboardSummary": {
    "path": [],
    "query": [
      "partnerId",
      "previewPartnerId",
      "days"
    ],
    "hasBody": false
  },
  "wyseaiReadCosts": {
    "path": [],
    "query": [
      "partnerId",
      "previewPartnerId",
      "months"
    ],
    "hasBody": false
  },
  "wyseaiListAvailableReports": {
    "path": [],
    "query": [
      "partnerId",
      "previewPartnerId"
    ],
    "hasBody": false
  },
  "wyseaiReadReportEmbed": {
    "path": [
      "report_id"
    ],
    "query": [
      "partnerId",
      "previewPartnerId"
    ],
    "hasBody": false
  },
  "wyseaiListAuditedCalls": {
    "path": [],
    "query": [
      "partnerId",
      "previewPartnerId",
      "page",
      "perPage",
      "status"
    ],
    "hasBody": false
  },
  "wyseaiReadAuditedCall": {
    "path": [
      "call_id"
    ],
    "query": [
      "partnerId",
      "previewPartnerId"
    ],
    "hasBody": false
  },
  "wyseaiSubmitAuditBatch": {
    "path": [],
    "query": [
      "partnerId"
    ],
    "hasBody": true
  },
  "wyseaiListAuditBatches": {
    "path": [],
    "query": [
      "partnerId",
      "previewPartnerId",
      "days",
      "page",
      "perPage",
      "q"
    ],
    "hasBody": false
  },
  "wyseaiReadAuditBatch": {
    "path": [
      "batch_id"
    ],
    "query": [
      "partnerId",
      "previewPartnerId"
    ],
    "hasBody": false
  },
  "wyseaiDownloadBatchOutput": {
    "path": [
      "batch_id"
    ],
    "query": [
      "channel",
      "partnerId",
      "previewPartnerId"
    ],
    "hasBody": false
  },
  "wyseaiRerunAuditBatch": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "wyseaiListGtaReferrals": {
    "path": [],
    "query": [
      "partnerId",
      "previewPartnerId",
      "page",
      "perPage",
      "q"
    ],
    "hasBody": false
  },
  "wyseaiReadGtaReferral": {
    "path": [
      "referral_id"
    ],
    "query": [
      "partnerId",
      "previewPartnerId"
    ],
    "hasBody": false
  },
  "wyseaiDownloadGtaReport": {
    "path": [
      "referral_id",
      "upload_id"
    ],
    "query": [
      "partnerId",
      "previewPartnerId"
    ],
    "hasBody": false
  },
  "wyseaiListClaims": {
    "path": [],
    "query": [
      "partnerId",
      "previewPartnerId",
      "days",
      "reg",
      "claimRef",
      "status",
      "page",
      "perPage"
    ],
    "hasBody": false
  },
  "wyseaiReadClaim": {
    "path": [
      "claim_id"
    ],
    "query": [
      "partnerId",
      "previewPartnerId"
    ],
    "hasBody": false
  },
  "wyseaiParseQuoteCheckEmail": {
    "path": [],
    "query": [
      "partnerId"
    ],
    "hasBody": true
  },
  "wyseaiListQuoteChecks": {
    "path": [],
    "query": [
      "partnerId",
      "previewPartnerId",
      "page",
      "perPage",
      "days",
      "q"
    ],
    "hasBody": false
  },
  "wyseaiSubmitQuoteCheck": {
    "path": [],
    "query": [
      "partnerId"
    ],
    "hasBody": true
  },
  "wyseaiReadQuoteCheck": {
    "path": [
      "run_id"
    ],
    "query": [
      "partnerId",
      "previewPartnerId"
    ],
    "hasBody": false
  },
  "wyseaiDownloadQuoteCheck": {
    "path": [
      "run_id"
    ],
    "query": [
      "channel",
      "partnerId",
      "previewPartnerId"
    ],
    "hasBody": false
  },
  "wyseaiTransportReadWorkspace": {
    "path": [],
    "query": [
      "partnerId",
      "previewPartnerId",
      "service_date"
    ],
    "hasBody": false
  },
  "wyseaiTransportReadSettings": {
    "path": [],
    "query": [
      "partnerId",
      "previewPartnerId"
    ],
    "hasBody": false
  },
  "wyseaiTransportUpdateSettings": {
    "path": [],
    "query": [
      "partnerId"
    ],
    "hasBody": true
  },
  "wyseaiTransportListWarehouses": {
    "path": [],
    "query": [
      "partnerId",
      "previewPartnerId"
    ],
    "hasBody": false
  },
  "wyseaiTransportCreateWarehouse": {
    "path": [],
    "query": [
      "partnerId"
    ],
    "hasBody": true
  },
  "wyseaiTransportUpdateWarehouse": {
    "path": [
      "warehouse_id"
    ],
    "query": [
      "partnerId"
    ],
    "hasBody": true
  },
  "wyseaiTransportListVans": {
    "path": [],
    "query": [
      "partnerId",
      "previewPartnerId"
    ],
    "hasBody": false
  },
  "wyseaiTransportCreateVan": {
    "path": [],
    "query": [
      "partnerId"
    ],
    "hasBody": true
  },
  "wyseaiTransportDeleteVan": {
    "path": [
      "van_id"
    ],
    "query": [
      "partnerId"
    ],
    "hasBody": false
  },
  "wyseaiTransportUpdateVan": {
    "path": [
      "van_id"
    ],
    "query": [
      "partnerId"
    ],
    "hasBody": true
  },
  "wyseaiTransportListDrivers": {
    "path": [],
    "query": [
      "partnerId",
      "previewPartnerId"
    ],
    "hasBody": false
  },
  "wyseaiTransportCreateDriver": {
    "path": [],
    "query": [
      "partnerId"
    ],
    "hasBody": true
  },
  "wyseaiTransportDeleteDriver": {
    "path": [
      "driver_id"
    ],
    "query": [
      "partnerId"
    ],
    "hasBody": false
  },
  "wyseaiTransportUpdateDriver": {
    "path": [
      "driver_id"
    ],
    "query": [
      "partnerId"
    ],
    "hasBody": true
  },
  "wyseaiTransportListJobs": {
    "path": [],
    "query": [
      "partnerId",
      "previewPartnerId",
      "service_date",
      "skip",
      "limit"
    ],
    "hasBody": false
  },
  "wyseaiTransportCreateJob": {
    "path": [],
    "query": [
      "partnerId"
    ],
    "hasBody": true
  },
  "wyseaiTransportDeleteJob": {
    "path": [
      "job_id"
    ],
    "query": [
      "partnerId"
    ],
    "hasBody": false
  },
  "wyseaiTransportUpdateJob": {
    "path": [
      "job_id"
    ],
    "query": [
      "partnerId"
    ],
    "hasBody": true
  },
  "wyseaiTransportImportJobs": {
    "path": [],
    "query": [
      "service_date",
      "partnerId"
    ],
    "hasBody": true
  },
  "wyseaiTransportValidateJobAddresses": {
    "path": [],
    "query": [
      "service_date",
      "partnerId"
    ],
    "hasBody": false
  },
  "wyseaiTransportListPlans": {
    "path": [],
    "query": [
      "partnerId",
      "previewPartnerId",
      "plan_date"
    ],
    "hasBody": false
  },
  "wyseaiTransportCreatePlan": {
    "path": [],
    "query": [
      "partnerId"
    ],
    "hasBody": true
  },
  "wyseaiTransportReadPlan": {
    "path": [
      "plan_id"
    ],
    "query": [
      "partnerId",
      "previewPartnerId"
    ],
    "hasBody": false
  },
  "wyseaiTransportOptimizeRoutes": {
    "path": [
      "plan_id"
    ],
    "query": [
      "partnerId"
    ],
    "hasBody": true
  },
  "wyseaiTransportReoptimizeRoutes": {
    "path": [
      "plan_id"
    ],
    "query": [
      "partnerId"
    ],
    "hasBody": true
  },
  "wyseaiTransportSavePlanVersion": {
    "path": [
      "plan_id"
    ],
    "query": [
      "partnerId"
    ],
    "hasBody": false
  },
  "wyseaiTransportApprovePlan": {
    "path": [
      "plan_id"
    ],
    "query": [
      "partnerId"
    ],
    "hasBody": false
  },
  "wyseaiTransportAdjustStopOrder": {
    "path": [
      "plan_id"
    ],
    "query": [
      "partnerId"
    ],
    "hasBody": true
  },
  "wyseaiTransportReassignJob": {
    "path": [
      "plan_id"
    ],
    "query": [
      "partnerId"
    ],
    "hasBody": true
  },
  "wyseaiTransportReadStartingLoads": {
    "path": [
      "plan_id"
    ],
    "query": [
      "partnerId",
      "previewPartnerId"
    ],
    "hasBody": false
  },
  "wyseaiTransportReadItinerary": {
    "path": [
      "token"
    ],
    "query": [
      "partnerId",
      "previewPartnerId"
    ],
    "hasBody": false
  },
  "wyseaiListWorkflows": {
    "path": [],
    "query": [
      "partnerId",
      "previewPartnerId",
      "page",
      "perPage",
      "source",
      "q"
    ],
    "hasBody": false
  },
  "wyseaiReadWorkflow": {
    "path": [
      "workflow_id"
    ],
    "query": [
      "partnerId",
      "previewPartnerId"
    ],
    "hasBody": false
  },
  "wyseaiListTeam": {
    "path": [],
    "query": [
      "partnerId"
    ],
    "hasBody": false
  },
  "wyseaiRemoveCapabilities": {
    "path": [
      "user_id"
    ],
    "query": [
      "partnerId"
    ],
    "hasBody": false
  },
  "wyseaiSetCapabilities": {
    "path": [
      "user_id"
    ],
    "query": [
      "partnerId"
    ],
    "hasBody": true
  },
  "wyseaiReadBranding": {
    "path": [],
    "query": [
      "partnerId"
    ],
    "hasBody": false
  },
  "wyseaiSetBranding": {
    "path": [],
    "query": [
      "partnerId"
    ],
    "hasBody": true
  },
  "wyseaiClearBrandingLogo": {
    "path": [],
    "query": [
      "partnerId"
    ],
    "hasBody": false
  },
  "wyseaiSetBrandingLogo": {
    "path": [],
    "query": [
      "partnerId"
    ],
    "hasBody": true
  },
  "wyseaiReadPartnerLogo": {
    "path": [],
    "query": [
      "partnerId",
      "previewPartnerId"
    ],
    "hasBody": false
  },
  "readInsurers": {
    "path": [],
    "query": [
      "skip",
      "limit"
    ],
    "hasBody": false
  },
  "createInsurer": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "deleteInsurer": {
    "path": [
      "id"
    ],
    "query": [],
    "hasBody": false
  },
  "readInsurer": {
    "path": [
      "id"
    ],
    "query": [],
    "hasBody": false
  },
  "updateInsurer": {
    "path": [
      "id"
    ],
    "query": [],
    "hasBody": true
  },
  "readPartnerRules": {
    "path": [],
    "query": [
      "skip",
      "limit"
    ],
    "hasBody": false
  },
  "createPartnerRule": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "deletePartnerRule": {
    "path": [
      "id"
    ],
    "query": [],
    "hasBody": false
  },
  "readPartnerRule": {
    "path": [
      "id"
    ],
    "query": [],
    "hasBody": false
  },
  "updatePartnerRule": {
    "path": [
      "id"
    ],
    "query": [],
    "hasBody": true
  },
  "readCircsGrades": {
    "path": [],
    "query": [
      "skip",
      "limit"
    ],
    "hasBody": false
  },
  "createCircsGrade": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "deleteCircsGrade": {
    "path": [
      "id"
    ],
    "query": [],
    "hasBody": false
  },
  "readCircsGrade": {
    "path": [
      "id"
    ],
    "query": [],
    "hasBody": false
  },
  "updateCircsGrade": {
    "path": [
      "id"
    ],
    "query": [],
    "hasBody": true
  },
  "readClaims": {
    "path": [],
    "query": [
      "skip",
      "limit"
    ],
    "hasBody": false
  },
  "createClaim": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "deleteClaim": {
    "path": [
      "id"
    ],
    "query": [],
    "hasBody": false
  },
  "readClaim": {
    "path": [
      "id"
    ],
    "query": [],
    "hasBody": false
  },
  "updateClaim": {
    "path": [
      "id"
    ],
    "query": [],
    "hasBody": true
  },
  "searchInsurerClaims": {
    "path": [],
    "query": [
      "reg",
      "policy_number",
      "external_policy_id",
      "limit"
    ],
    "hasBody": false
  },
  "importClaimStatePayload": {
    "path": [],
    "query": [
      "partner_id"
    ],
    "hasBody": true
  },
  "importInboundClaim": {
    "path": [],
    "query": [
      "partner_id"
    ],
    "hasBody": true
  },
  "listInsurerClaimFieldChanges": {
    "path": [
      "claim_id"
    ],
    "query": [
      "fieldPrefix",
      "limit",
      "offset"
    ],
    "hasBody": false
  },
  "getInsurerClaim": {
    "path": [
      "claim_id"
    ],
    "query": [],
    "hasBody": false
  },
  "getInsurerPolicy": {
    "path": [
      "policy_id"
    ],
    "query": [],
    "hasBody": false
  },
  "readComplaints": {
    "path": [],
    "query": [
      "skip",
      "limit"
    ],
    "hasBody": false
  },
  "createNewComplaint": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "deleteExistingComplaint": {
    "path": [
      "complaint_id"
    ],
    "query": [],
    "hasBody": false
  },
  "readComplaint": {
    "path": [
      "complaint_id"
    ],
    "query": [],
    "hasBody": false
  },
  "updateExistingComplaint": {
    "path": [
      "complaint_id"
    ],
    "query": [],
    "hasBody": true
  },
  "readComplaintsByReferral": {
    "path": [
      "referral_id"
    ],
    "query": [
      "skip",
      "limit"
    ],
    "hasBody": false
  },
  "readReferralAllocationsBytype": {
    "path": [],
    "query": [
      "partnertype",
      "skip",
      "limit"
    ],
    "hasBody": false
  },
  "createReferralAllocation": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "deleteReferralAllocation": {
    "path": [
      "id"
    ],
    "query": [],
    "hasBody": false
  },
  "readReferralAllocation": {
    "path": [
      "id"
    ],
    "query": [],
    "hasBody": false
  },
  "updateReferralAllocation": {
    "path": [
      "id"
    ],
    "query": [],
    "hasBody": true
  },
  "partnerUpdateAllocation": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "reallocateReferral": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "getReferralAllocationAuditHistory": {
    "path": [
      "id"
    ],
    "query": [
      "skip",
      "limit"
    ],
    "hasBody": false
  },
  "referralsGenerateSummary": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "referralsGetSummaryStatus": {
    "path": [
      "task_id"
    ],
    "query": [],
    "hasBody": false
  },
  "referralsGetLatestSummary": {
    "path": [
      "referral_id"
    ],
    "query": [],
    "hasBody": false
  },
  "referralsGetSummaryHistory": {
    "path": [
      "referral_id"
    ],
    "query": [
      "limit"
    ],
    "hasBody": false
  },
  "referralsGetSummaryDetail": {
    "path": [
      "summary_id"
    ],
    "query": [],
    "hasBody": false
  },
  "readReferrals": {
    "path": [],
    "query": [
      "partnertype",
      "skip",
      "limit"
    ],
    "hasBody": false
  },
  "createReferral": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "referralTableData": {
    "path": [],
    "query": [
      "partnertype",
      "page",
      "page_size",
      "search_term",
      "sort_field",
      "sort_direction",
      "include_aiclaims_projections",
      "only_gta2_completed"
    ],
    "hasBody": false
  },
  "referralChartData": {
    "path": [],
    "query": [
      "chart_type",
      "partnertype",
      "page",
      "page_size",
      "search_term"
    ],
    "hasBody": false
  },
  "countReferralsByStatus": {
    "path": [],
    "query": [
      "statuses"
    ],
    "hasBody": false
  },
  "createBulkSummaryOperation": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "cleanupTimedOutBulkOperations": {
    "path": [],
    "query": [],
    "hasBody": false
  },
  "getBulkOperationsHistory": {
    "path": [],
    "query": [
      "skip",
      "limit"
    ],
    "hasBody": false
  },
  "getBulkOperationStatus": {
    "path": [
      "operation_id"
    ],
    "query": [],
    "hasBody": false
  },
  "getBulkOperationReferrals": {
    "path": [
      "operation_id"
    ],
    "query": [
      "skip",
      "limit"
    ],
    "hasBody": false
  },
  "streamBulkOperationUpdates": {
    "path": [
      "operation_id"
    ],
    "query": [],
    "hasBody": false
  },
  "streamBulkOperationsHistory": {
    "path": [],
    "query": [],
    "hasBody": false
  },
  "getBulkOperationsMetrics": {
    "path": [],
    "query": [
      "days"
    ],
    "hasBody": false
  },
  "deleteReferral": {
    "path": [
      "id"
    ],
    "query": [],
    "hasBody": false
  },
  "readReferral": {
    "path": [
      "id"
    ],
    "query": [],
    "hasBody": false
  },
  "updateReferral": {
    "path": [
      "id"
    ],
    "query": [],
    "hasBody": true
  },
  "listAvailableWorkflows": {
    "path": [],
    "query": [],
    "hasBody": false
  },
  "generateSummary": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "getSummaryStatus": {
    "path": [
      "task_id"
    ],
    "query": [],
    "hasBody": false
  },
  "streamSummaryStatus": {
    "path": [
      "task_id"
    ],
    "query": [],
    "hasBody": false
  },
  "getLatestSummary": {
    "path": [
      "referral_id"
    ],
    "query": [],
    "hasBody": false
  },
  "getRecentSummaryRuns": {
    "path": [],
    "query": [
      "skip",
      "limit",
      "status",
      "version",
      "fromDate",
      "toDate",
      "hireStatus",
      "workflowId"
    ],
    "hasBody": false
  },
  "getSummaryHistory": {
    "path": [
      "referral_id"
    ],
    "query": [
      "limit"
    ],
    "hasBody": false
  },
  "getSummaryDetail": {
    "path": [
      "summary_id"
    ],
    "query": [],
    "hasBody": false
  },
  "getBotScoresForReferral": {
    "path": [
      "referral_id"
    ],
    "query": [],
    "hasBody": false
  },
  "getAuditReport": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "downloadMattAuditPdf": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "generateWorkflowClaimsAudit": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "generateMattClaimsAudit": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "submitSummaryFeedback": {
    "path": [
      "referral_id"
    ],
    "query": [],
    "hasBody": true
  },
  "grafanaAlertWebhook": {
    "path": [],
    "query": [],
    "hasBody": false
  },
  "readSourceRates": {
    "path": [],
    "query": [
      "skip",
      "limit"
    ],
    "hasBody": false
  },
  "createSourceRate": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "deleteSourceRate": {
    "path": [
      "id"
    ],
    "query": [],
    "hasBody": false
  },
  "readSourceRate": {
    "path": [
      "id"
    ],
    "query": [],
    "hasBody": false
  },
  "updateSourceRate": {
    "path": [
      "id"
    ],
    "query": [],
    "hasBody": true
  },
  "expireSourceRates": {
    "path": [],
    "query": [
      "expiry_date",
      "vehicle_type",
      "source_partner_id",
      "tier"
    ],
    "hasBody": false
  },
  "readSupplierRates": {
    "path": [],
    "query": [
      "skip",
      "limit"
    ],
    "hasBody": false
  },
  "createSupplierRate": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "deleteSupplierRate": {
    "path": [
      "id"
    ],
    "query": [],
    "hasBody": false
  },
  "readSupplierRate": {
    "path": [
      "id"
    ],
    "query": [],
    "hasBody": false
  },
  "updateSupplierRate": {
    "path": [
      "id"
    ],
    "query": [],
    "hasBody": true
  },
  "expireSupplierRates": {
    "path": [],
    "query": [
      "expiry_date",
      "vehicle_type",
      "supplier_partner_id",
      "source_partner_id"
    ],
    "hasBody": false
  },
  "readVehGroups": {
    "path": [],
    "query": [
      "skip",
      "limit"
    ],
    "hasBody": false
  },
  "createVehGroup": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "readUniqueTypes": {
    "path": [],
    "query": [
      "_skip",
      "_limit"
    ],
    "hasBody": false
  },
  "deleteVehGroup": {
    "path": [
      "id"
    ],
    "query": [],
    "hasBody": false
  },
  "readVehGroup": {
    "path": [
      "id"
    ],
    "query": [],
    "hasBody": false
  },
  "updateVehGroup": {
    "path": [
      "id"
    ],
    "query": [],
    "hasBody": true
  },
  "readAuthorities": {
    "path": [],
    "query": [
      "skip",
      "limit"
    ],
    "hasBody": false
  },
  "createAuthority": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "deleteAuthority": {
    "path": [
      "authority_id"
    ],
    "query": [],
    "hasBody": false
  },
  "readAuthority": {
    "path": [
      "authority_id"
    ],
    "query": [],
    "hasBody": false
  },
  "updateAuthority": {
    "path": [
      "authority_id"
    ],
    "query": [],
    "hasBody": true
  },
  "requestUploadCsv": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "createRequest": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "requestUploadCsvNoPartnerRules": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "manualRequestNoPartnerRules": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "readUserPartners": {
    "path": [],
    "query": [
      "skip",
      "limit"
    ],
    "hasBody": false
  },
  "createUserPartner": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "deleteUserPartner": {
    "path": [
      "id"
    ],
    "query": [],
    "hasBody": false
  },
  "readUserPartner": {
    "path": [
      "id"
    ],
    "query": [],
    "hasBody": false
  },
  "updateUserPartner": {
    "path": [
      "id"
    ],
    "query": [],
    "hasBody": true
  },
  "readAnnies": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "readAnniesVoice": {
    "path": [],
    "query": [],
    "hasBody": false
  },
  "liabilityScoreFast": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "readRoleAllocations": {
    "path": [],
    "query": [
      "skip",
      "limit"
    ],
    "hasBody": false
  },
  "createRoleAllocation": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "deleteRoleAllocation": {
    "path": [
      "id"
    ],
    "query": [],
    "hasBody": false
  },
  "readRoleAllocation": {
    "path": [
      "id"
    ],
    "query": [],
    "hasBody": false
  },
  "updateRoleAllocation": {
    "path": [
      "id"
    ],
    "query": [],
    "hasBody": true
  },
  "readRoles": {
    "path": [],
    "query": [
      "skip",
      "limit"
    ],
    "hasBody": false
  },
  "createRole": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "deleteRole": {
    "path": [
      "id"
    ],
    "query": [],
    "hasBody": false
  },
  "readRole": {
    "path": [
      "id"
    ],
    "query": [],
    "hasBody": false
  },
  "updateRole": {
    "path": [
      "id"
    ],
    "query": [],
    "hasBody": true
  },
  "readRolePermissions": {
    "path": [],
    "query": [
      "skip",
      "limit"
    ],
    "hasBody": false
  },
  "createRolePermission": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "deleteRolePermission": {
    "path": [
      "id"
    ],
    "query": [],
    "hasBody": false
  },
  "readRolePermission": {
    "path": [
      "id"
    ],
    "query": [],
    "hasBody": false
  },
  "updateRolePermission": {
    "path": [
      "id"
    ],
    "query": [],
    "hasBody": true
  },
  "validateOtp": {
    "path": [
      "user_id"
    ],
    "query": [
      "otp",
      "loginid"
    ],
    "hasBody": false
  },
  "uploadFiles": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "downloadClaimFile": {
    "path": [],
    "query": [
      "file_id",
      "referral_id"
    ],
    "hasBody": false
  },
  "getDownloadStatus": {
    "path": [],
    "query": [
      "referral_id"
    ],
    "hasBody": false
  },
  "downloadMultipleFiles": {
    "path": [],
    "query": [
      "referral_id"
    ],
    "hasBody": true
  },
  "getNotificationOptions": {
    "path": [
      "referral_id"
    ],
    "query": [],
    "hasBody": false
  },
  "addNotesBatch": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "getNotes": {
    "path": [
      "referral_id"
    ],
    "query": [],
    "hasBody": false
  },
  "addNote": {
    "path": [
      "referral_id"
    ],
    "query": [],
    "hasBody": true
  },
  "deleteNote": {
    "path": [
      "note_id"
    ],
    "query": [],
    "hasBody": false
  },
  "updateNote": {
    "path": [
      "note_id"
    ],
    "query": [
      "note"
    ],
    "hasBody": false
  },
  "getComplaintNotes": {
    "path": [
      "complaint_id"
    ],
    "query": [],
    "hasBody": false
  },
  "addComplaintNote": {
    "path": [
      "complaint_id"
    ],
    "query": [],
    "hasBody": true
  },
  "listReferralCsvColumns": {
    "path": [],
    "query": [],
    "hasBody": false
  },
  "parseEmail": {
    "path": [],
    "query": [],
    "hasBody": false
  },
  "incomingCall": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "generateInvoiceRequestPdfBulk": {
    "path": [],
    "query": [
      "partner_id"
    ],
    "hasBody": false
  },
  "readInvoices": {
    "path": [],
    "query": [
      "skip",
      "limit"
    ],
    "hasBody": false
  },
  "updateInvoiceStatus": {
    "path": [
      "id"
    ],
    "query": [
      "status"
    ],
    "hasBody": false
  },
  "payInvoice": {
    "path": [
      "id"
    ],
    "query": [],
    "hasBody": false
  },
  "payInvoiceWithLines": {
    "path": [
      "id"
    ],
    "query": [],
    "hasBody": false
  },
  "creditInvoice": {
    "path": [
      "id"
    ],
    "query": [],
    "hasBody": false
  },
  "deleteInvoice": {
    "path": [
      "id"
    ],
    "query": [],
    "hasBody": false
  },
  "readInvoice": {
    "path": [
      "id"
    ],
    "query": [],
    "hasBody": false
  },
  "triggerInvoiceGeneration": {
    "path": [],
    "query": [
      "billing_date"
    ],
    "hasBody": false
  },
  "getInvoiceTaskStatus": {
    "path": [
      "task_id"
    ],
    "query": [],
    "hasBody": false
  },
  "generateInvoiceLinesDirect": {
    "path": [],
    "query": [
      "billing_date"
    ],
    "hasBody": false
  },
  "generateInvoiceRequestLinesDirect": {
    "path": [],
    "query": [
      "billing_date"
    ],
    "hasBody": false
  },
  "getInvoiceLines": {
    "path": [],
    "query": [
      "type",
      "status",
      "partner_id",
      "start_date",
      "end_date",
      "skip",
      "limit"
    ],
    "hasBody": false
  },
  "updateInvoiceLineStatus": {
    "path": [
      "id"
    ],
    "query": [
      "status"
    ],
    "hasBody": false
  },
  "updateInvoiceLineRate": {
    "path": [
      "id"
    ],
    "query": [
      "rate"
    ],
    "hasBody": false
  },
  "updateInvoiceLineAmount": {
    "path": [
      "id"
    ],
    "query": [
      "amount",
      "billed_amount"
    ],
    "hasBody": false
  },
  "payInvoiceLine": {
    "path": [
      "id"
    ],
    "query": [],
    "hasBody": false
  },
  "generateInvoiceToXero": {
    "path": [],
    "query": [],
    "hasBody": false
  },
  "getInvoiceRequestLines": {
    "path": [],
    "query": [
      "status",
      "skip",
      "limit"
    ],
    "hasBody": false
  },
  "getPendingRequestLinesBySupplier": {
    "path": [],
    "query": [
      "skip",
      "limit"
    ],
    "hasBody": false
  },
  "generateInvoiceRequestPdf": {
    "path": [
      "line_id"
    ],
    "query": [],
    "hasBody": false
  },
  "generateApiUsageBillingLinesDirect": {
    "path": [],
    "query": [
      "billing_date"
    ],
    "hasBody": false
  },
  "generatePartnerApiUsageBillingDirect": {
    "path": [
      "partner_id"
    ],
    "query": [
      "billing_date",
      "generate_invoice"
    ],
    "hasBody": false
  },
  "getApiUsageBillingSummaryAll": {
    "path": [],
    "query": [
      "partner_id",
      "start_date",
      "end_date"
    ],
    "hasBody": false
  },
  "getApiUsageBillingSummary": {
    "path": [
      "partner_id"
    ],
    "query": [
      "start_date",
      "end_date"
    ],
    "hasBody": false
  },
  "generateApiUsageInvoices": {
    "path": [],
    "query": [],
    "hasBody": false
  },
  "getXeroOnlineInvoiceUrl": {
    "path": [
      "invoice_id"
    ],
    "query": [],
    "hasBody": false
  },
  "getPartnerApiBillingConfigs": {
    "path": [],
    "query": [
      "skip",
      "limit"
    ],
    "hasBody": false
  },
  "createPartnerApiBillingConfig": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "deletePartnerApiBillingConfig": {
    "path": [
      "partner_id"
    ],
    "query": [],
    "hasBody": false
  },
  "getPartnerApiBillingConfig": {
    "path": [
      "partner_id"
    ],
    "query": [],
    "hasBody": false
  },
  "updatePartnerApiBillingConfig": {
    "path": [
      "partner_id"
    ],
    "query": [],
    "hasBody": true
  },
  "getApiUsage": {
    "path": [],
    "query": [
      "partner_id",
      "endpoint",
      "billing_status",
      "start_date",
      "end_date",
      "skip",
      "limit"
    ],
    "hasBody": false
  },
  "updateApiUsageBillingStatus": {
    "path": [
      "usage_id"
    ],
    "query": [
      "billing_status"
    ],
    "hasBody": false
  },
  "getWorkflowBillingLedgerSummary": {
    "path": [],
    "query": [
      "partner_id",
      "billing_period"
    ],
    "hasBody": false
  },
  "listWorkflowBillingLedgerEvents": {
    "path": [],
    "query": [
      "partner_id",
      "billing_period",
      "skip",
      "limit",
      "includeEvaluation"
    ],
    "hasBody": false
  },
  "getWorkflowRateConfigs": {
    "path": [],
    "query": [
      "partner_id",
      "workflow_key",
      "skip",
      "limit"
    ],
    "hasBody": false
  },
  "createWorkflowRateConfig": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "getPartnerWorkflowRates": {
    "path": [
      "partner_id"
    ],
    "query": [],
    "hasBody": false
  },
  "deleteWorkflowRateConfig": {
    "path": [
      "config_id"
    ],
    "query": [],
    "hasBody": false
  },
  "getWorkflowRateConfig": {
    "path": [
      "config_id"
    ],
    "query": [],
    "hasBody": false
  },
  "updateWorkflowRateConfig": {
    "path": [
      "config_id"
    ],
    "query": [],
    "hasBody": true
  },
  "triggerRepairBilling": {
    "path": [],
    "query": [
      "start_date",
      "end_date",
      "partner_id"
    ],
    "hasBody": false
  },
  "getEligibleRepairs": {
    "path": [],
    "query": [
      "start_date",
      "end_date",
      "partner_id",
      "include_billed"
    ],
    "hasBody": false
  },
  "getRepairAllocationBillingStatus": {
    "path": [
      "allocation_id"
    ],
    "query": [],
    "hasBody": false
  },
  "getProfilerStats": {
    "path": [],
    "query": [],
    "hasBody": false
  },
  "enableProfiler": {
    "path": [],
    "query": [],
    "hasBody": false
  },
  "disableProfiler": {
    "path": [],
    "query": [],
    "hasBody": false
  },
  "resetProfiler": {
    "path": [],
    "query": [],
    "hasBody": false
  },
  "uploadEdgeCsv": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "getEdgeImportStatus": {
    "path": [
      "task_id"
    ],
    "query": [],
    "hasBody": false
  },
  "createAccessRequest": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "xeroSeed": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "xeroLogin": {
    "path": [],
    "query": [],
    "hasBody": false
  },
  "xeroCallback": {
    "path": [],
    "query": [
      "code",
      "state"
    ],
    "hasBody": false
  },
  "xeroStatus": {
    "path": [],
    "query": [],
    "hasBody": false
  },
  "xeroLogout": {
    "path": [],
    "query": [],
    "hasBody": false
  },
  "listXeroCompanies": {
    "path": [],
    "query": [],
    "hasBody": false
  },
  "switchXeroCompany": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "xeroWebhook": {
    "path": [],
    "query": [],
    "hasBody": false
  },
  "listBatchPostprocessors": {
    "path": [],
    "query": [
      "name_contains"
    ],
    "hasBody": false
  },
  "listAiPromptConfigs": {
    "path": [],
    "query": [],
    "hasBody": false
  },
  "createPromptConfig": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "listAiPromptSlotsRoute": {
    "path": [],
    "query": [],
    "hasBody": false
  },
  "getPromptHistory": {
    "path": [],
    "query": [
      "model",
      "variant",
      "agent_key"
    ],
    "hasBody": false
  },
  "getAiPromptConfig": {
    "path": [
      "version",
      "model"
    ],
    "query": [],
    "hasBody": false
  },
  "deletePromptConfig": {
    "path": [
      "config_id"
    ],
    "query": [],
    "hasBody": false
  },
  "updatePromptConfig": {
    "path": [
      "config_id"
    ],
    "query": [],
    "hasBody": true
  },
  "createPromptDraft": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "updatePromptDraft": {
    "path": [
      "config_id"
    ],
    "query": [],
    "hasBody": true
  },
  "promotePromptDraft": {
    "path": [
      "config_id"
    ],
    "query": [],
    "hasBody": false
  },
  "retirePromptConfig": {
    "path": [
      "config_id"
    ],
    "query": [],
    "hasBody": false
  },
  "listReportTemplates": {
    "path": [],
    "query": [
      "active_only"
    ],
    "hasBody": false
  },
  "createReportTemplate": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "deleteReportTemplate": {
    "path": [
      "template_id"
    ],
    "query": [],
    "hasBody": false
  },
  "getReportTemplate": {
    "path": [
      "template_id"
    ],
    "query": [],
    "hasBody": false
  },
  "updateReportTemplate": {
    "path": [
      "template_id"
    ],
    "query": [],
    "hasBody": true
  },
  "duplicateReportTemplate": {
    "path": [
      "template_id"
    ],
    "query": [],
    "hasBody": false
  },
  "previewReportTemplatePdf": {
    "path": [
      "template_id"
    ],
    "query": [],
    "hasBody": false
  },
  "previewReportTemplate": {
    "path": [
      "template_id"
    ],
    "query": [
      "channel",
      "batch_layout"
    ],
    "hasBody": false
  },
  "monitoringGetRateLimitHealth": {
    "path": [],
    "query": [],
    "hasBody": false
  },
  "monitoringGetRateLimitMetrics": {
    "path": [],
    "query": [
      "hours"
    ],
    "hasBody": false
  },
  "monitoringGetRateLimitAlerts": {
    "path": [],
    "query": [],
    "hasBody": false
  },
  "monitoringGetRateLimitStatistics": {
    "path": [],
    "query": [
      "days"
    ],
    "hasBody": false
  },
  "monitoringGetRedisStatus": {
    "path": [],
    "query": [],
    "hasBody": false
  },
  "monitoringForceCleanup": {
    "path": [],
    "query": [],
    "hasBody": false
  },
  "monitoringGetDashboardData": {
    "path": [],
    "query": [],
    "hasBody": false
  },
  "adminResetUserRateLimit": {
    "path": [],
    "query": [
      "user_id",
      "resource"
    ],
    "hasBody": false
  },
  "adminResetIpRateLimit": {
    "path": [],
    "query": [
      "ip_address",
      "resource"
    ],
    "hasBody": false
  },
  "adminGetLlmCostCap": {
    "path": [],
    "query": [],
    "hasBody": false
  },
  "adminUpdateLlmCostCap": {
    "path": [],
    "query": [
      "cap_usd"
    ],
    "hasBody": false
  },
  "adminGetConfigurationSummary": {
    "path": [],
    "query": [],
    "hasBody": false
  },
  "adminValidateConfiguration": {
    "path": [],
    "query": [],
    "hasBody": false
  },
  "reloadConfiguration": {
    "path": [],
    "query": [],
    "hasBody": false
  },
  "seedDefaultConfig": {
    "path": [],
    "query": [],
    "hasBody": false
  },
  "adminReadRateLimitConfigs": {
    "path": [],
    "query": [
      "skip",
      "limit"
    ],
    "hasBody": false
  },
  "createRateLimitConfigEndpoint": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "deleteRateLimitConfigEndpoint": {
    "path": [
      "config_id"
    ],
    "query": [],
    "hasBody": false
  },
  "readRateLimitConfig": {
    "path": [
      "config_id"
    ],
    "query": [],
    "hasBody": false
  },
  "updateRateLimitConfigEndpoint": {
    "path": [
      "config_id"
    ],
    "query": [],
    "hasBody": true
  },
  "readRateLimitConfigByEndpoint": {
    "path": [
      "endpoint_path"
    ],
    "query": [
      "method"
    ],
    "hasBody": false
  },
  "adminReadBulkOperationConfigs": {
    "path": [],
    "query": [
      "skip",
      "limit"
    ],
    "hasBody": false
  },
  "createBulkOperationConfigEndpoint": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "deleteBulkOperationConfigEndpoint": {
    "path": [
      "config_id"
    ],
    "query": [],
    "hasBody": false
  },
  "readBulkOperationConfig": {
    "path": [
      "config_id"
    ],
    "query": [],
    "hasBody": false
  },
  "updateBulkOperationConfigEndpoint": {
    "path": [
      "config_id"
    ],
    "query": [],
    "hasBody": true
  },
  "readBulkOperationConfigByName": {
    "path": [
      "config_name"
    ],
    "query": [],
    "hasBody": false
  },
  "clearConfigurationCache": {
    "path": [],
    "query": [],
    "hasBody": false
  },
  "getCacheStatus": {
    "path": [],
    "query": [],
    "hasBody": false
  },
  "updateCacheTtl": {
    "path": [],
    "query": [
      "ttl_seconds"
    ],
    "hasBody": false
  },
  "getEndpointAnalytics": {
    "path": [],
    "query": [
      "hours",
      "top_n"
    ],
    "hasBody": false
  },
  "getRateLimitRecommendations": {
    "path": [],
    "query": [],
    "hasBody": false
  },
  "getRealTimeStats": {
    "path": [],
    "query": [],
    "hasBody": false
  },
  "getRequestLogs": {
    "path": [],
    "query": [
      "endpoint",
      "method",
      "rate_limited_only",
      "hours",
      "limit"
    ],
    "hasBody": false
  },
  "exportAnalyticsData": {
    "path": [],
    "query": [
      "hours",
      "format"
    ],
    "hasBody": false
  },
  "listTables": {
    "path": [],
    "query": [],
    "hasBody": false
  },
  "readTableRows": {
    "path": [
      "table_name"
    ],
    "query": [
      "skip",
      "limit",
      "sort_by",
      "sort_order",
      "search"
    ],
    "hasBody": false
  },
  "createTableRow": {
    "path": [
      "table_name"
    ],
    "query": [],
    "hasBody": true
  },
  "deleteTableRow": {
    "path": [
      "table_name",
      "row_id"
    ],
    "query": [],
    "hasBody": false
  },
  "readTableRow": {
    "path": [
      "table_name",
      "row_id"
    ],
    "query": [],
    "hasBody": false
  },
  "updateTableRow": {
    "path": [
      "table_name",
      "row_id"
    ],
    "query": [],
    "hasBody": true
  },
  "listAppSettings": {
    "path": [],
    "query": [
      "skip",
      "limit"
    ],
    "hasBody": false
  },
  "createSetting": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "deleteSetting": {
    "path": [
      "setting_id"
    ],
    "query": [],
    "hasBody": false
  },
  "getAppSettingEndpoint": {
    "path": [
      "setting_id"
    ],
    "query": [],
    "hasBody": false
  },
  "updateSetting": {
    "path": [
      "setting_id"
    ],
    "query": [],
    "hasBody": true
  },
  "validateSettingByKey": {
    "path": [],
    "query": [
      "key",
      "environment"
    ],
    "hasBody": false
  },
  "rehydratePrivacyToken": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "purgeExpiredPrivacyMappings": {
    "path": [],
    "query": [],
    "hasBody": false
  },
  "listMetabaseReportSchedules": {
    "path": [],
    "query": [
      "skip",
      "limit"
    ],
    "hasBody": false
  },
  "createMetabaseReportScheduleEndpoint": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "deleteMetabaseReportScheduleEndpoint": {
    "path": [
      "schedule_id"
    ],
    "query": [],
    "hasBody": false
  },
  "getMetabaseReportScheduleEndpoint": {
    "path": [
      "schedule_id"
    ],
    "query": [],
    "hasBody": false
  },
  "updateMetabaseReportScheduleEndpoint": {
    "path": [
      "schedule_id"
    ],
    "query": [],
    "hasBody": true
  },
  "listMetabaseReportCatalog": {
    "path": [],
    "query": [
      "skip",
      "limit"
    ],
    "hasBody": false
  },
  "createMetabaseReportCatalogEndpoint": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "deleteMetabaseReportCatalogEndpoint": {
    "path": [
      "catalog_id"
    ],
    "query": [],
    "hasBody": false
  },
  "getMetabaseReportCatalogEndpoint": {
    "path": [
      "catalog_id"
    ],
    "query": [],
    "hasBody": false
  },
  "updateMetabaseReportCatalogEndpoint": {
    "path": [
      "catalog_id"
    ],
    "query": [],
    "hasBody": true
  },
  "listAvailableMetabaseEmbeds": {
    "path": [],
    "query": [],
    "hasBody": false
  },
  "createMetabaseEmbedToken": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "recordPerformanceMetric": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "analyticsHealth": {
    "path": [],
    "query": [],
    "hasBody": false
  },
  "readSecurityTestResults": {
    "path": [],
    "query": [
      "skip",
      "limit",
      "environment",
      "test_suite_name",
      "status",
      "from_date",
      "to_date"
    ],
    "hasBody": false
  },
  "createTestResult": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "readSecurityTestResult": {
    "path": [
      "result_id"
    ],
    "query": [],
    "hasBody": false
  },
  "readSecurityTestSummary": {
    "path": [],
    "query": [
      "environment"
    ],
    "hasBody": false
  },
  "cleanupOldResults": {
    "path": [],
    "query": [
      "retention_days"
    ],
    "hasBody": false
  },
  "runSecurityTests": {
    "path": [
      "test_suite"
    ],
    "query": [
      "environment",
      "dry_run"
    ],
    "hasBody": false
  },
  "checkTestSuiteHealth": {
    "path": [],
    "query": [],
    "hasBody": false
  },
  "getAvailableTasks": {
    "path": [],
    "query": [],
    "hasBody": false
  },
  "listTaskConfigs": {
    "path": [],
    "query": [
      "skip",
      "limit",
      "enabled"
    ],
    "hasBody": false
  },
  "createTaskSchedule": {
    "path": [],
    "query": [],
    "hasBody": true
  },
  "deleteTaskSchedule": {
    "path": [
      "config_id"
    ],
    "query": [],
    "hasBody": false
  },
  "getTaskConfig": {
    "path": [
      "config_id"
    ],
    "query": [],
    "hasBody": false
  },
  "updateTaskSchedule": {
    "path": [
      "config_id"
    ],
    "query": [],
    "hasBody": true
  },
  "schedulerUpdateTaskSchedule": {
    "path": [
      "config_id"
    ],
    "query": [],
    "hasBody": true
  },
  "getTaskExecutionHistory": {
    "path": [],
    "query": [
      "task_schedule_id",
      "status",
      "skip",
      "limit"
    ],
    "hasBody": false
  },
  "getExecutionDetail": {
    "path": [
      "execution_id"
    ],
    "query": [],
    "hasBody": false
  },
  "triggerTaskNow": {
    "path": [
      "config_id"
    ],
    "query": [],
    "hasBody": false
  },
  "getRedbeatStatus": {
    "path": [],
    "query": [],
    "hasBody": false
  },
  "previewScheduleConfig": {
    "path": [
      "config_id"
    ],
    "query": [],
    "hasBody": false
  },
  "triggerRedbeatSync": {
    "path": [],
    "query": [],
    "hasBody": false
  },
  "listWorkflowRuns": {
    "path": [],
    "query": [
      "skip",
      "limit",
      "referralId",
      "fromDate",
      "toDate"
    ],
    "hasBody": false
  },
  "getWorkflowRun": {
    "path": [
      "task_id"
    ],
    "query": [],
    "hasBody": false
  },
  "getPartnerIssueRollup": {
    "path": [],
    "query": [
      "fromDate",
      "toDate",
      "partnerId",
      "workflowKey",
      "agentName"
    ],
    "hasBody": false
  },
  "exportPartnerIssueCsv": {
    "path": [],
    "query": [
      "fromDate",
      "toDate",
      "partnerId",
      "workflowKey",
      "agentName"
    ],
    "hasBody": false
  }
}
